import { get } from 'lodash'

import { TFeature } from './types'
import { useFeatures } from './use-features'

export const useIsDynamicFeatureEnabled = (name?: TFeature) => {
  const features = useFeatures()
  return !!name && get(features, name, true /* features are on by default */)
}
